import React from 'react';
import Content, { options } from '@components/Content';
import { CallToActionProps } from 'ech-components/src/components/CallToAction';
import { ContentReference } from '~/components/Content/helpers';

const callToActionService = (data: {
  actions: [];
  leadText?: { leadText?: string };
  title?: string;
  type?: string;
}) => {
  const callToActionProps: CallToActionProps = data?.actions
    ? {
        items: data.actions.map(
          ({
            title,
            text,
            icon,
          }: {
            title: string;
            text: {
              raw: string;
              references: ContentReference[];
            };
            icon?: {
              file: {
                url: string;
              };
            };
          }) => ({
            title,
            richtext: <Content content={text} options={options} nested />,
            iconSrc: icon?.file?.url,
          }),
        ),
        title: data.title,
        lead: data.leadText?.leadText,
        type: data.type,
        gridItemSize: { zero: 12, medium: 10, large: 8 },
        gridItemPush: { zero: 0, medium: 1, large: 2 },
      }
    : null;

  return callToActionProps;
};

export default callToActionService;
